import { BaseShippingZonesClient } from "../types/clients";
import { ExpressPointsData, LocationAddress, ShippingZone } from "@core/types";
import { client } from "../../../../apollo";
import { ShippingZonesQuery, ShippingZonesDocument } from "../../../../generated/graphql";

type ZONE_TYPE = ShippingZonesQuery["customerShippingZones"]["edges"][number]["node"];

class ShippingZonesClient extends BaseShippingZonesClient {
  async getShippingZones() {
    const zones: ZONE_TYPE[] = await client
      .query<ShippingZonesQuery>({
        query: ShippingZonesDocument,
      })
      .then((res) => {
        if (res.data) {
          return res.data.customerShippingZones.edges.map((item) => item.node);
        }

        return [];
      });

    const data: ShippingZone[] = zones.map(({ code, title }) => ({ id: code, name: title }));
    return data;
  }

  async getCheckAddressForExpress(address: LocationAddress): Promise<ExpressPointsData> {
    const response = await this.instance.post<ExpressPointsData>("/wp-json/parhato-api/v1/check-address-for-express", {
      address,
    });

    return response.data;
  }
}

export default ShippingZonesClient;
